<div class="configure-cameras-dialog">
    <div class="dialog-header">
        <div class="title">{{ 'ADD_CAMERA_WIZARD.CONFIGURE_DIALOG.TITLE'|translate:{count: cameras.length} }}</div>
        <span class="ui-icon-close close-btn" (click)="onCancel()"></span>
    </div>

    <div class="dialog-content">
        <!-- Camera Type Section -->
        <div class="config-section">
            <div class="section-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURE_DIALOG.CAMERA_TYPE'|translate }}</div>
            <mat-select class="flex-row ui-selector camera-type-selector" [(ngModel)]="selectedCameraType">
              <mat-option [value]="CameraType.StaticCamera">{{ cameraTypeStr[CameraType.StaticCamera]|translate }}</mat-option>
              <mat-option [value]="CameraType.CeilingMountedFishEye">{{ cameraTypeStr[CameraType.CeilingMountedFishEye]|translate }}</mat-option>
              <mat-option [value]="CameraType.WallMountedFishEye">{{ cameraTypeStr[CameraType.WallMountedFishEye]|translate }}</mat-option>
              <mat-option [value]="CameraType.ThermalCamera">{{ cameraTypeStr[CameraType.ThermalCamera]|translate }}</mat-option>
              <mat-option [value]="CameraType.PTZCamera">{{ cameraTypeStr[CameraType.PTZCamera]|translate }}</mat-option>
              <mat-option [value]="CameraType.MobileCamera">{{ cameraTypeStr[CameraType.MobileCamera]|translate }}</mat-option>
              <mat-option [value]="CameraType.CeilingMounted">{{ cameraTypeStr[CameraType.CeilingMounted]|translate }}</mat-option>
            </mat-select>
        </div>

        <!-- Audio Stream Section -->
        <div class="config-section">
            <div class="audio-toggles">
                <div class="audio-toggle-row">
                    <ui-toggle [(ngModel)]="audioEnabled" (ngModelChange)="toggleAudio()"></ui-toggle>
                    <div class="audio-label">
                        <div class="audio-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURE_DIALOG.AUDIO_STREAM'|translate }}</div>
                        <div class="audio-desc">{{ 'ADD_CAMERA_WIZARD.CONFIGURE_DIALOG.IF_AVAILABLE'|translate }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="config-section">
            <div class="auto-config-row">
                <ui-toggle [(ngModel)]="autoConfigure"></ui-toggle>
                <div class="auto-config-label">
                    <div class="auto-config-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.AUTO_CONFIG'|translate }}</div>
                    <div class="auto-config-desc">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.AUTO_CONFIG_TOOLTIP'|translate }}</div>
                </div>
            </div>
        </div>

        <div class="vertical-divider">&nbsp;</div>

        <!-- Storage Section -->
        <div class="config-section">
            <div class="section-title">{{ 'ADD_CAMERA_WIZARD.CONFIGURATION.STORAGE'|translate }}</div>
            <app-camera-storage-settings-tab 
                #storageSettings
                [standalone]="true"
                (onStorageSettingsChange)="onStorageChanged()">
            </app-camera-storage-settings-tab>
        </div>
    </div>

    <div class="dialog-footer">
        <ui-button type="secondary" [text]="'COMMON.CANCEL'|translate" (clickAction)="onCancel()"></ui-button>
        <ui-button type="primary" [text]="'ADD_CAMERA_WIZARD.CONFIGURE_DIALOG.SAVE_CHANGES'|translate" (clickAction)="onSave()"></ui-button>
    </div>
</div>